var render = function render(){var _vm=this,_c=_vm._self._c;return _c('quillEditor',{style:({height: _vm.contentHeight}),attrs:{"options":_vm.editorOptions},on:{"change":_vm.contentChange},model:{value:(_vm.editorContent),callback:function ($$v) {_vm.editorContent=$$v},expression:"editorContent"}})
}
var staticRenderFns = []

export { render, staticRenderFns }